exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-outline-secondary[data-v-54f38415]{color:#6a6969}.btn-outline-secondary[data-v-54f38415]:hover{color:#f7f7f7;background-color:#6a6969;border-color:#6a6969}.hidden[data-v-54f38415]{opacity:0}.speech-bubble-tooltip[data-v-54f38415]{background:#f7f7f7;border-radius:.4em;padding:15px 10px;font-size:24px;color:#6a6969;float:left;top:34px;left:-45px;min-width:300px;z-index:100000}.speech-bubble-tooltip[data-v-54f38415]:after{content:\"\";position:absolute;top:0;left:45px;width:0;height:0;border:20px solid transparent;border-bottom-color:#f7f7f7;border-top:0;margin-left:-20px;margin-top:-20px;z-index:100000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54f38415","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/general/help-left.vue
// module id = 1947
// module chunks = 0